export const CAROUSEL_HEIGHT = 35;
export const WIDE_GUTTER_WIDTH = 171;
export const NARROW_GUTTER_WIDTH = 171;
export const XL_LABEL_WIDTH = 110;
export const LG_LABEL_WIDTH = 101;
export const SM_LABEL_WIDTH = 35;
export const LABEL_HEIGHT = 20;
export const LABEL_AND_GAP_HEIGHT = 25;
export const TEXT_BASE_HEIGHT = 15;
export const LABEL_DROPDOWN_WIDTH = 400;
export const HEADER_HEIGHT = 60;
export const LABEL_MIN_GAP = 5;
export const RESIZE_REFRESH_DELAY = 500;
